import React from "react";
import classNames from "classnames";
import Section from "./Section";

/**
 * @param {string} t1  Title title top
 * @param {string} t2  Title title middle
 * @param {string} t3  Title title bottom
 * @param {string} href Title action link
 * @param {string} action   Title action text
 *
 * @return  {component}
 */

const Title = (props) => {
  const { id, t1, t2, t3, href, action, contrast } = props;

  const classNameContainer = classNames(
    "my-[80px] justify-center text-center mt-[150px]"
  );

  const classTitleContainer = classNames();

  const classT1 = classNames("text-xl", {
    "text-neutral-100": contrast,
    "text-neutral-700": !contrast,
  });

  const classT2 = classNames(
    "leading-tight sm:leading-tight font-bold text-4xl sm:text-5xl pt-5",
    {
      "text-neutral-900": !contrast,
      "text-white": contrast,
    },
    "dark:text-white"
  );

  const classT3 = classNames(
    "mt-5",
    "text:sm  md:text-md lg:text-xl",
    {
      "text-neutral-300": contrast,
      "text-neutral-700": !contrast,
    },
    "dark:text-white"
  );

  const classBtn = classNames(
    "px-4 py-4 text-base font-medium",
    "border  border-transparent ",
    "items-center rounded-xl",
    "cursor-pointer",
    "text-white bg-neutral-900 hover:bg-neutral-800",
    {
      "bg-white !text-neutral-900 hover:!bg-neutral-300": contrast,
    }
  );

  return (
    <div className={classNameContainer}>
      <div className={classTitleContainer}>
        <Section className="px-2.5">
          {t1 && <h1 className={classT1}>{t1}</h1>}
          {t2 && <h1 className={classT2}>{t2}</h1>}
          {t3 && <h1 className={classT3}>{t3}</h1>}
          {action && (
            <div className="pt-10">
              <a id={id} className={classBtn} href={href}>
                {action}
              </a>
            </div>
          )}
        </Section>
      </div>
    </div>
  );
};

export default Title;
